export default "__VITE_ASSET__DicZ9A4m__"